<template>
  <StepDescriptionModal
    :open="isStepDescriptionModalOpen"
    @close-modal="isStepDescriptionModalOpen = false"
    :flow-type="'quiet-period'"
  />
  <!-- <S1DisclaimerModal
    :open="is_s1_disclaimer_modal_open"
    @close-modal="is_s1_disclaimer_modal_open = false"
  /> -->

  <div
    class="relative min-w-[16rem] max-w-[16rem] md:min-w-0 md:max-w-full"
    :class="offering.header_text ? 'pt-6' : ''"
  >
    <!-- Blue header - positioned behind -->
    <div
      v-if="offering.header_text"
      class="absolute -top-1 left-0 right-0 h-40 rounded-t-3xl"
      :class="
        offering.header_text === 'Short-term'
          ? 'bg-gradient-to-bl from-[#5793b8]/70 from-15% to-[#c6dfef] to-30%'
          : 'bg-gradient-to-bl from-[#ff8800]/70 from-15% to-[#f6c984] to-30%'
      "
    ></div>
    <span
      v-if="offering.header_text"
      class="absolute top-1.5 px-5.5 text-sm font-bold font-inter font-stretch-normal not-italic leading-none tracking-normal text-left text-always-dark"
      >{{ offering.header_text }}</span
    >
    <!-- Main card content - overlaps the header -->
    <div
      v-if="offering.name != 'Regulation D (Adamantium)'"
      class="relative w-full overflow-hidden rounded-3xl bg-container-bg md:p-5 p-4 md:h-[20rem]"
      :class="
        offering.header_text
          ? ''
          : 'md:bg-gradient-to-bl from-[#fba63d]/50 from-10% to-container-bg to-30%'
      "
    >
      <div class="flex items-center md:justify-start gap-3 mb-6">
        <img :src="offering.icon" alt="OfferingIcon" class="h-8 w-8 z-10 \" />
        <span
          class="text-sm font-inter font-stretch-normal not-italic leading-none tracking-normal text-left text-strongest"
        >
          {{ offering.name }}
        </span>
        <!-- <span
          v-if="offering.header_text"
          class="font-inter md:hidden rounded-md bg-[#eeb257] px-2 py-[.125rem] text-xs font-semibold font-stretch-normal not-italic leading-none tracking-normal text-left text-always-dark"
          >{{ offering.header_text }}</span
        > -->
      </div>

      <div class="md:mb-8 mb-[1.375rem]">
        <div class="flex items-start gap-[.125rem]">
          <h2
            class="text-[1.75rem] font-medium font-stretch-normal not-italic leading-none tracking-[-0.56] text-left text-strongest mb-[2px]"
          >
            Up to {{ offering.interest_rate }}%
          </h2>
          <!-- <span
            class="text-xl font-semibold ml-[.375rem] font-stretch-normal not-italic leading-none tracking-[-0.4] text-left text-light"
            >{{ offering.name === "Reg D" ? "*2" : "*1" }}
          </span> -->
        </div>
        <p
          class="font-inter text-base font-medium font-stretch-normal not-italic leading-none tracking-normal text-left text-strong"
        >
          annual interest rate
        </p>
      </div>

      <Button
        @click="handleMakeInvestmentClick(offering)"
        label
        size="lg-md"
        variant="primary-grey-neo"
        class="w-full md:w-fit"
      >
        <template #label>
          <span class="text-lg font-inter">
            Start with ${{ commaSeparateThousands(offering.minimum_investment) }}</span
          >
        </template>
      </Button>
      <div class="md:mt-10 mt-5 space-y-[4px] md:absolute bottom-5">
        <!-- <div
          v-if="
            dataStore.s1_offerings_in_quiet_period &&
            offering.name === 'Registered Offering (S1)'
          "
          @click="isStepDescriptionModalOpen = true"
          class="flex flex-row items-center cursor-pointer"
        >
          <div class="flex items-center gap-1">
            <AsteriskNotice variant="info" size="medium" />
            <span
              class="font-inter text-xs font-stretch-normal not-italic leading-none tracking-normal text-left text-light"
              >Open for reservation only.</span
            >
          </div>
          <Icon name="Info" class="w-4 h-4 ml-2 text-light" />
        </div> -->
        <div class="flex items-center text-gray-500 text-sm">
          <span
            v-if="offering.type === 'Reg D'"
            class="font-inter text-xs font-stretch-normal not-italic leading-none tracking-normal text-left text-light"
            >Accredited investors only
          </span>
        </div>
        <div class="flex items-center text-gray-500 text-sm">
          <span
            class="font-inter text-xs font-stretch-normal not-italic leading-none tracking-normal text-left text-light"
            >{{ formatCurrencyShort(offering.minimum_investment) + " minimum investment" }}
          </span>
        </div>
        <div class="flex items-center justify-between text-gray-500 text-sm">
          <a
            :href="
              offering.type == 'Reg D'
                ? 'https://phoenixenergy.com/ppm/?_gl=1*93svuu*_gcl_au*MTg4NTkxMjM0OS4xNzcxNTQ2OTI4'
                : 'https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&filenum=333-282862'
            "
            target="_blank"
            class="font-inter flex items-center text-xs font-stretch-normal not-italic leading-none tracking-normal text-left text-light"
            >{{
              offering.type == "Reg D"
                ? "View our Reg D PPM"
                : "View our Registered Offering Prospectus"
            }}
            <Icon name="ArrowUpRight" class="w-4 h-4 ml-2 text-light" />
          </a>
        </div>
      </div>
    </div>
    <!-- Adamantium Offering -->
    <div
      v-else
      class="relative overflow-hidden md:w-[16rem] rounded-3xl bg-container-bg md:p-5 p-4 md:h-[20rem]"
    >
      <div class="flex items-center gap-3 mb-6">
        <img :src="offering.icon" alt="OfferingIcon" class="h-8 w-8 z-10" />
        <span
          class="text-sm font-inter font-stretch-normal not-italic leading-none tracking-normal text-left text-strongest"
        >
          {{ offering.name }}
        </span>
      </div>

      <div class="md:mb-8 mb-[1.375rem]">
        <div class="flex items-start gap-[.125rem]">
          <h2
            class="text-[1.75rem] font-medium font-stretch-normal not-italic leading-none tracking-[-0.56] text-left text-strongest"
          >
            Up to {{ offering.interest_rate }}%
          </h2>
          <!-- <span
            class="text-xl font-semibold ml-[.375rem] font-stretch-normal not-italic leading-none tracking-[-0.4] text-left text-light"
            >*3
          </span> -->
        </div>
        <p
          class="font-inter text-base font-medium font-stretch-normal not-italic leading-none tracking-normal text-left text-strong"
        >
          annual interest rate
        </p>
      </div>

      <Button
        @click="redirect('https://adamantium.phoenixenergy.com/')"
        label
        size="lg-sm"
        variant="paper-primary-neo"
        class="w-full md:w-fit"
      >
        <template #label><span class="text-base md:text-lg font-inter">Contact Us</span></template>
      </Button>
      <div class="md:mt-14 mt-5 md:absolute bottom-5">
        <div class="flex items-center justify-between text-gray-500 text-sm">
          <span
            class="font-inter text-xs font-stretch-normal not-italic leading-none tracking-normal text-left text-light"
            >{{ formatCurrencyShort(offering.minimum_investment) + " minimum investment" }}
          </span>
        </div>
        <div class="flex items-center justify-between text-gray-500 text-sm pb-1">
          <a
            href="#"
            class="font-inter flex items-center text-xs font-stretch-normal not-italic leading-none tracking-normal text-left text-light"
            >Sponsored by Phoenix Energy
            <Icon name="ArrowUpRight" class="w-4 h-4 ml-2 text-light" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { Button, Icon } from "@/components";
import { commaSeparateThousands } from "@/utilities";
import { useAnalytics } from "@/composables/useAnalytics";
import AsteriskNotice from "@/components/AsteriskNotice.vue";
import StepDescriptionModal from "./PurchaseFlowUtilities/StepDescriptionModal.vue";
import S1DisclaimerModal from "@/components/S1DisclaimerModal.vue";
import { usePurchaseFlowStore, useDataStore, useCrudStore } from "@/stores";
const router = useRouter();

const purchaseFlowStore = usePurchaseFlowStore();
const dataStore = useDataStore();
const crudStore = useCrudStore();
const { trackOfferingCtaClicked } = useAnalytics();

const isStepDescriptionModalOpen = ref(false);
const is_s1_disclaimer_modal_open = ref(false);

const props = defineProps({
  offering: {
    type: Object,
    default: {},
  },
});

const isS1InQuietPeriod = computed(() => {
  return (
    dataStore.s1_offerings_in_quiet_period && props.offering.name === "Registered Offering (S1)"
  );
});

const handleMakeInvestmentClick = async (offering) => {
  trackOfferingCtaClicked(
    `Start with $${commaSeparateThousands(offering.minimum_investment)}`,
    offering.minimum_investment,
    offering.type
  );
  // if (isS1InQuietPeriod.value) {
  //   is_s1_disclaimer_modal_open.value = true;
  //   return;
  // }
  // 1. Resolve the best matching offering
  const matchingOfferings = dataStore.offerings.filter((off) =>
    offering.type === "Reg D" && !offering.is_short_term
      ? off.type === offering.type &&
        off.tier === purchaseFlowStore.regDTier &&
        off.is_short_term === offering.is_short_term
      : off.type === offering.type && off.is_short_term === offering.is_short_term
  );

  const selectedOffering = matchingOfferings.sort((a, b) => b.interest_rate - a.interest_rate)[0];

  purchaseFlowStore.selected_offering = selectedOffering;

  // 2. Set short-term flags
  if (offering.is_short_term) {
    purchaseFlowStore.current_investment.is_compounded = true;
    purchaseFlowStore.current_investment.is_short_term = true;
  } else {
    purchaseFlowStore.current_investment.is_short_term = false;
  }

  // 3. Default the amount based on offering type
  const defaultAmount =
    offering.type === "Reg D" ? 25000 : selectedOffering.is_short_term ? 1000 : 5000;
  const currentAmount = purchaseFlowStore.current_investment.amount || 0;
  const previousOfferingType = purchaseFlowStore.current_investment.offering_type;
  const isReturningToSameType = previousOfferingType === offering.type;

  // Reinvestors arrive here with the amount already set to what's available to roll
  // over — never stomp it with the offering's default starting amount.
  const shouldResetAmount =
    !purchaseFlowStore.selected_rollover &&
    (!isReturningToSameType || currentAmount <= defaultAmount);

  if (shouldResetAmount) {
    purchaseFlowStore.current_investment.amount = defaultAmount;
  }

  // 4. Navigate
  purchaseFlowStore.current_step = 1;
  router.push("/make-an-investment");
  await purchaseFlowStore.saveInvestmentProgress();
};

function formatCurrencyShort(value) {
  if (value == null || isNaN(value)) return "$0";

  const abs = Math.abs(value);
  const sign = value < 0 ? "-" : "";

  if (abs >= 1000000) {
    return `${sign}$${(abs / 1_000_000).toFixed(1).replace(/\.0$/, "")} million`;
  }

  if (abs >= 1000) {
    return `${sign}$${(abs / 1_000).toFixed(1).replace(/\.0$/, "")}k`;
  }

  return `${sign}$${abs.toLocaleString()}`;
}

function redirect(link) {
  trackOfferingCtaClicked("Contact Us", null, "Adamantium");
  let log = {
    step: "Experiment CTA",
    substep: "Contact Us (Adamantium)",
    status: "Navigated",
    message: "",
    url: link,
    validation_details: null,
  };
  log = dataStore.setDefaultFields(log, "investoractivity");
  crudStore.insert("investoractivity", [log]);
  window.open(link, "_blank");
}
</script>
